'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
exports.authReducer =
  exports.AUTH_REFRESHTOKEN_KEY =
  exports.AUTH_ACCESSTOKEN_KEY =
    void 0;
const actiontypes_1 = require('./actiontypes');
const initialState = {
  initialized: false,
  busy: 0,
  clientId: process.env.AUTH_CLIENT_ID,
  redirectUri: process.env.AUTH_REDIRECT_URI,
  scope: process.env.AUTH_SCOPE,
  state: 'state',
  codeVerifier: 'code_verifier',
  codeChallenge: 'S256_hashed_code_verifier',
  codeChallengeMethod: process.env.AUTH_CODE_CHALLENGE_METHOD,
  serverOrigin: process.env.AUTH_SERVER_ORIGIN,
  signInRoute: '/signin',
  signOutRoute: '/signin',
  redirectAfterSignInRoute: '/',
  defaultRedirectAfterSignInRoute: '/',
  accessDeniedMessage: '',
  defaultAccessDeniedMessage: 'Access denied.',
  accessDeniedMessageTimeout: 5000,
  defaultAccessDeniedMessageTimeout: 5000,
};
exports.AUTH_ACCESSTOKEN_KEY = 'kode.auth.accessToken';
exports.AUTH_REFRESHTOKEN_KEY = 'kode.auth.refreshToken';
exports.AUTH_IDTOKEN_KEY = 'kode.auth.idToken';
function authReducer(state = initialState, action) {
  switch (action.type) {
    // --- AUTH ---------------------------------
    case actiontypes_1.AUTH_INITIALIZED:
      return Object.assign(Object.assign({}, state), {
        initialized: action.initialized,
      });
    case actiontypes_1.AUTH_BUSY:
      return Object.assign(Object.assign({}, state), {
        busy: Math.max(0, action.busy ? state.busy + 1 : state.busy - 1),
      });
    case actiontypes_1.AUTH_ACCESSTOKEN:
      window.localStorage.setItem(exports.AUTH_ACCESSTOKEN_KEY, action.token);
      return Object.assign(Object.assign({}, state), {
        accessToken: action.token,
        decodedAccessToken: action.decodedToken,
      });
    case actiontypes_1.AUTH_REFRESHTOKEN:
      window.localStorage.setItem(exports.AUTH_REFRESHTOKEN_KEY, action.token);
      return Object.assign(Object.assign({}, state), {
        refreshToken: action.token,
      });
    case actiontypes_1.AUTH_IDTOKEN:
      window.localStorage.setItem(exports.AUTH_IDTOKEN_KEY, action.token);
      return Object.assign(Object.assign({}, state), { idToken: action.token });
    case actiontypes_1.AUTH_CLEAR_ACCESSTOKEN:
      window.localStorage.removeItem(exports.AUTH_ACCESSTOKEN_KEY);
      return Object.assign(Object.assign({}, state), {
        accessToken: undefined,
        decodedAccessToken: undefined,
      });
    case actiontypes_1.AUTH_CLEAR_REFRESHTOKEN:
      window.localStorage.removeItem(exports.AUTH_REFRESHTOKEN_KEY);
      return Object.assign(Object.assign({}, state), {
        refreshToken: undefined,
      });
    case actiontypes_1.AUTH_INIT_AUTHORIZE_GRANT:
      return Object.assign(Object.assign({}, state), {
        state: action.state,
        codeVerifier: action.codeVerifier,
        codeChallenge: action.codeChallenge,
      });
    case actiontypes_1.AUTH_RESET_AUTHORIZE_GRANT:
      return Object.assign(Object.assign({}, state), {
        state: '',
        codeVerifier: '',
        codeChallenge: '',
      });
    case actiontypes_1.AUTH_INIT_REFRESH_GRANT:
      return Object.assign(Object.assign({}, state), { state: action.state });
    case actiontypes_1.AUTH_RESET_REFRESH_GRANT:
      return Object.assign(Object.assign({}, state), { state: '' });
    case actiontypes_1.AUTH_SIGNOUT:
      window.localStorage.removeItem(exports.AUTH_ACCESSTOKEN_KEY);
      window.localStorage.removeItem(exports.AUTH_REFRESHTOKEN_KEY);
      return Object.assign(Object.assign({}, state), {
        authorizationCode: undefined,
        accessToken: undefined,
        decodedAccessToken: undefined,
        refreshToken: undefined,
      });
    case actiontypes_1.AUTH_RESET:
      return Object.assign({}, initialState);
    case actiontypes_1.AUTH_RESET_SUBSCRIBERS:
      return Object.assign(Object.assign({}, state), {
        resetSubscribers: action.subscribers,
      });
    case actiontypes_1.AUTH_SIGN_IN_ROUTE:
      return Object.assign(Object.assign({}, state), {
        signInRoute: action.route,
      });
    case actiontypes_1.AUTH_SIGN_OUT_ROUTE:
      return Object.assign(Object.assign({}, state), {
        signOutRoute: action.route,
      });
    case actiontypes_1.AUTH_REDIRECT_AFTER_SIGN_IN_ROUTE:
      return Object.assign(Object.assign({}, state), {
        redirectAfterSignInRoute:
          action.route || state.defaultRedirectAfterSignInRoute,
      });
    case actiontypes_1.AUTH_DEFAULT_REDIRECT_AFTER_SIGN_IN_ROUTE:
      return Object.assign(Object.assign({}, state), {
        defaultRedirectAfterSignInRoute: action.route,
      });
    case actiontypes_1.AUTH_ACCESS_DENIED_MESSAGE:
      return Object.assign(Object.assign({}, state), {
        accessDeniedMessage: action.msg,
      });
    case actiontypes_1.AUTH_DEFAULT_ACCESS_DENIED_MESSAGE:
      return Object.assign(Object.assign({}, state), {
        defaultAccessDeniedMessage: action.msg,
      });
    case actiontypes_1.AUTH_ACCESS_DENIED_MESSAGE_TIMEOUT:
      return Object.assign(Object.assign({}, state), {
        accessDeniedMessageTimeout: action.timeout,
      });
    case actiontypes_1.AUTH_DEFAULT_ACCESS_DENIED_MESSAGE_TIMEOUT:
      return Object.assign(Object.assign({}, state), {
        defaultAccessDeniedMessageTimeout: action.timeout,
      });
    default:
      return state;
  }
}
exports.authReducer = authReducer;
